import React, { useState, useMemo } from 'react';

// Components & Hooks
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import history from 'aurora-utils/history';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import { ADGMImage } from 'aurora-components';
import { useClipboard } from 'aurora-hooks';
import withStyles from '@material-ui/core/styles/withStyles';
// Utils & Constant
import PropTypes from 'prop-types';
import isArray from 'lodash/isArray';
import { applicationActions } from 'aurora-utils/constants';
import { keyEmptyCheck } from 'aurora-utils/utils';

// styles
import styles from './styles';

const SuccessScreenV2 = props => {
  const {
    children,
    classes,
    title,
    subTitle,
    applicationNumber,
    applicationAction,
    downloadCertificatesList,
    submissionButtonContent,
    submissionHandler,
    extraHeaderActions,
    downloadPaymentHandler,
  } = props;

  const { copy } = useClipboard();
  const getIcon = action => {
    switch (action) {
      case applicationActions.success:
        return 'successIconV2.svg';
      case applicationActions.terminate:
        return 'errorIconV2.svg';
      case applicationActions.reject:
        return 'discardIconV2.svg';
      case applicationActions.refuse:
        return 'refused.svg';
      default:
        return null;
    }
  };

  const getTitleColorClass = action => {
    switch (action) {
      case applicationActions.success:
        return classes.headerTitleSuccess;
      case applicationActions.terminate:
        return classes.headerTitleTerminate;
      case applicationActions.reject:
        return classes.headerTitleReject;
      case applicationActions.refuse:
        return classes.headerTitleRefused;
      default:
        return '';
    }
  };
  const [isDownloadMenuOpen, setDownloadMenuOpen] = useState(null);
  const handleClose = () => {
    setDownloadMenuOpen(null);
  };
  const successScreenDocuments = useMemo(() => {
    return {
      certificate: downloadCertificatesList?.filter(item => item?.primary),
      receipts: downloadCertificatesList?.filter(item => !item?.primary),
    };
  }, [downloadCertificatesList]);
  return (
    <Container className={classes.successScreenContainer}>
      <div className={classes.successScreenHeader}>
        {/* <Hidden smDown> */}
        <ADGMImage className={classes.successScreenHeaderImg} name={getIcon(applicationAction)} alt='status img' />
        {/* {/ </Hidden> /} */}
        <div className={classes.successScreenHeaderContent}>
          <Typography
            variant='h6'
            component='h1'
            className={`${classes.successScreenHeaderTitle} ${getTitleColorClass(applicationAction)}`}
          >
            {keyEmptyCheck(title)}
          </Typography>

          {subTitle &&
            (typeof subTitle === 'string' ? (
              <Typography className={classes.successScreenHeaderSubTitle} variant='body1'>
                {keyEmptyCheck(subTitle)}
              </Typography>
            ) : (
              subTitle
            ))}

          {isArray(downloadCertificatesList) && (
            <Grid container spacing={2} className={classes.mt16} direction='column' alignItems='center'>
              {successScreenDocuments?.certificate
                ?.filter(item => item?.primary)
                ?.map(certificate => (
                  <Grid item>
                    <Button
                      variant='body1'
                      className={
                        certificate?.primary
                          ? classes.successScreenHeaderDownloadButton
                          : classes.successScreenHeaderDownloadPaymentButton
                      }
                      onClick={certificate?.downloadHandler}
                    >
                      <svg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        {' '}
                        <g clipPath='url(#clip0_2142_14911)'>
                          {' '}
                          <path
                            d='M8.85098 17.7C10.6083 19.4574 13.4576 19.4574 15.215 17.7L15.215 17.7L18.427 14.488C19.0229 13.9125 19.0394 12.9629 18.4639 12.367C17.8883 11.7711 16.9388 11.7546 16.3429 12.3301C16.3304 12.3422 16.3181 12.3545 16.306 12.367L13.523 15.149L13.5 1.5C13.5 0.671578 12.8284 0 12 0C11.1716 0 10.5 0.671578 10.5 1.5L10.521 15.127L7.76002 12.366C7.16414 11.7905 6.21455 11.807 5.63902 12.4028C5.07759 12.9841 5.07759 13.9057 5.63902 14.487L8.85098 17.7Z'
                            fill='#0088FF'
                          />{' '}
                          <path
                            d='M22.5 14.5C21.6716 14.5 21 15.1716 21 16V20.591C20.9994 20.8166 20.8167 20.9995 20.591 21H3.40898C3.18333 20.9994 3.00052 20.8166 3 20.591V16C3 15.1716 2.32842 14.5 1.5 14.5C0.671578 14.5 0 15.1716 0 16V20.591C0.00220313 22.4728 1.52719 23.9978 3.40898 24H20.591C22.4728 23.9978 23.9977 22.4728 24 20.591V16C24 15.1716 23.3284 14.5 22.5 14.5Z'
                            fill='#0088FF'
                          />{' '}
                        </g>{' '}
                        <defs>
                          {' '}
                          <clipPath id='clip0_2142_14911'>
                            {' '}
                            <rect width='24' height='24' fill='white' />{' '}
                          </clipPath>{' '}
                        </defs>{' '}
                      </svg>
                      {keyEmptyCheck(certificate?.title)}
                    </Button>
                  </Grid>
                ))}
              {Array.isArray(successScreenDocuments?.receipts) && successScreenDocuments?.receipts?.length > 0 && (
                <>
                  <Button
                    aria-controls='download-menu'
                    aria-haspopup='true'
                    onClick={e => setDownloadMenuOpen(e.currentTarget)}
                    className={classes.downloadPaymentBtn}
                  >
                    <ADGMImage name='Download-Icon-blue.svg' alt='Icon' />
                    {keyEmptyCheck('download_payment_receipts')}
                    <ADGMImage name={isDownloadMenuOpen ? 'angle-up-blue.svg' : 'angle-down-blue.svg'} alt='return' />
                  </Button>
                  <Menu
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    id='download-menu'
                    anchorEl={isDownloadMenuOpen}
                    open={Boolean(isDownloadMenuOpen)}
                    onClose={() => setDownloadMenuOpen(null)}
                    getContentAnchorEl={null}
                    classes={{
                      paper: classes.navMenuDropdown,
                      list: classes.menuList,
                    }}
                  >
                    {successScreenDocuments.receipts.map(receipt => (
                      <MenuItem
                        key={receipt?.title}
                        onClick={() => {
                          receipt?.downloadHandler();
                          handleClose();
                        }}
                      >
                        <ADGMImage name='Download-Icon-blue.svg' alt='Icon' />
                        {keyEmptyCheck(receipt?.title)}
                      </MenuItem>
                    ))}
                    {/* {Array.isArray(successScreenDocuments?.receipts) && successScreenDocuments?.receipts?.length > 1 && (
                      <MenuItem
                        onClick={() => {
                          // Execute all download handlers
                          Promise.all(successScreenDocuments.receipts.map(receipt => receipt?.downloadHandler()));
                          handleClose();
                        }}
                      >
                        <ADGMImage name='Download-Icon.svg' alt='Icon' />
                        {keyEmptyCheck('download_both_receipts')}
                      </MenuItem>
                    )} */}
                  </Menu>
                </>
              )}
            </Grid>
          )}
          {extraHeaderActions}
          {typeof downloadPaymentHandler === 'function' && (
            <Grid className={classes.downloadPaymentReceiptContainer} item xs={12} md={12}>
              <Button className={classes.successScreenHeaderDownloadButton} onClick={downloadPaymentHandler}>
                <ADGMImage name='Download-Icon.svg' alt='Icon' width='16px' height='16px' />
                {keyEmptyCheck('download_payment_receipt')}
              </Button>
            </Grid>
          )}
        </div>
      </div>
      {applicationNumber && (
        <>
          {/* <Hidden mdUp>
            <div className={classNames(classes.detailItemHorizontal, classes.applicationNumberContainer)}>
              <Typography className={classes.applicationNumber}>
                {keyEmptyCheck('Application_ID')}:&nbsp;
                <span className={classes.applicationNumberBold}>{applicationNumber}</span>
                <span className={classes.applicationNumberIcon}>
                  <ADGMImage name='ApplicationIDIconDark.svg' alt='copyIcon' onClick={() => copy(applicationNumber)} />
                </span>
              </Typography>
            </div>
          </Hidden> */}

          <div className={classes.successScreenMainContent}>
            <Box className={classes.successBoxContent} p={2}>
              {/* Application ID */}
              <Box>
                <ADGMItemDetails
                  label='Application_ID'
                  labelClass={classes.applicationNumberLabel}
                  value={
                    <>
                      <span>{applicationNumber}</span>
                      <span className={classes.applicationNumberIcon}>
                        <ADGMImage
                          name='ApplicationIDIconDark.svg'
                          alt='copyIcon'
                          onClick={() => copy(applicationNumber)}
                        />
                      </span>
                    </>
                  }
                />
              </Box>
            </Box>

            {children}
          </div>
        </>
      )}
      <div className={classes.successScreenFooter}>
        <Button variant='contained' className={classes.successScreenFooterButton} onClick={submissionHandler}>
          {keyEmptyCheck(submissionButtonContent)}
        </Button>
      </div>
    </Container>
  );
};

SuccessScreenV2.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  applicationNumber: PropTypes.string.isRequired,
  applicationAction: PropTypes.string.isRequired,
  downloadCertificatesList: PropTypes.array,
  submissionHandler: PropTypes.func,
  submissionButtonContent: PropTypes.string,
  extraHeaderActions: PropTypes.node,
  downloadPaymentHandler: PropTypes.func,
};

SuccessScreenV2.defaultProps = {
  subTitle: '',
  submissionButtonContent: 'go_to_applications',
  downloadCertificatesList: [],
  extraHeaderActions: undefined,
  downloadPaymentHandler: undefined,
  submissionHandler: () => history.push('/app/applications?type=applications'),
};

export default withStyles(styles)(SuccessScreenV2);
